if ( typeof window.renderHelperCart !== 'function' ) {
	window.renderHelperCart = (text) => {

		const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
		const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
		const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

		const cartItems = document.getElementById('AjaxCartForm');
		cartItems.innerHTML = cartFormInnerHTML;
		cartItems.ajaxifyCartItems();

		document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
			elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
		});
		document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
			elm.innerHTML = cartItems.querySelector('[data-cart-total]').innerHTML;
		});

		document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

		return sectionInnerHTML;

	};
}

if ( window.KROWN && KROWN.functions && typeof KROWN.functions.dispatchStandardEvent !== 'function' ) {
	KROWN.functions.dispatchStandardEvent = (className, target, detail) => {
		const SE = window.Shopify && window.Shopify.StandardEvents;
		if ( ! SE || typeof SE[className] !== 'function' ) return;
		try {
			( target || document ).dispatchEvent(new SE[className](detail));
		} catch (error) {
			console.warn(`standard-events: ${className}`, error);
		}
	};
}

if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');
			const prefix = window.KT_PREFIX || '';

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector(`.${prefix}remove`);
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector(`.${prefix}qty`);
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;
			const prefix = window.KT_PREFIX || '';

			this.form.classList.add(`${prefix}processing`);
			if ( this.querySelector(`.${prefix}alert`) ) {
				this.querySelector(`.${prefix}alert`).remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						alert = document.createElement('span');
						alert.classList.add(`${prefix}alert`, `${prefix}alert--error`);
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
						KROWN.functions.eventDispatcher('krown:cart:error', {
							error: alert.textContent
						});

						KROWN.functions.dispatchStandardEvent('CartErrorEvent', this, {
							error: alert.textContent
						});
					}
					return fetch(`?section_id=${window.KT_FILE_PREFIX || ''}helper-cart`);
				})
				.then(response => response.text())
				.then(text => {

					window.renderHelperCart(text);

					if ( alert !== null ) {
						this.form.prepend(alert);
					}

					const event = new Event('cart-updated');
					this.dispatchEvent(event);

					const updatedItem = this.querySelector(`[data-js-cart-item][data-line="${item.dataset.line}"]`);
					if ( updatedItem ) {
						KROWN.functions.eventDispatcher('krown:cart:update', {
							itemKey: updatedItem.dataset.id,
							itemQty: updatedItem.dataset.qty,
							itemVariantId: updatedItem.dataset.variant,
							itemProductId: updatedItem.dataset.productId
						});
					}

					if ( alert === null ) {
						KROWN.functions.dispatchStandardEvent('CartLinesUpdateEvent', this, {
							action: newQty === 0 ? 'remove' : 'update',
							context: 'cart',
							lines: [{
								id: item.dataset.id,
								quantity: newQty
							}],
							promise: Promise.resolve({ cart: null })
						});
					}

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add(`${prefix}alert`, `${prefix}alert--error`);
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove(`${prefix}processing`);
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this._prefix = window.KT_PREFIX || '';
			this.querySelector(`.${this._prefix}qty-minus`).addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector(`.${this._prefix}qty-plus`).addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector(`.${this._prefix}qty`).value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}


if ( ! window.refreshCart ) {

	window.refreshCart = (openDrawer = true) => {
		
		fetch(`?section_id=${window.KT_FILE_PREFIX || ''}helper-cart`)
			.then(response => response.text())
			.then(text => {

			window.renderHelperCart(text);

			if ( document.querySelector('[data-js-site-cart-sidebar]') && openDrawer === true ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, {
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body
						}).then(() => {
							KROWN.functions.dispatchStandardEvent('CartNoteUpdateEvent', this, {
								context: 'cart',
								note: event.target.value,
								promise: Promise.resolve({ cart: null })
							});
						});
		  		}, 300)
				);
      }
    }
  );
}

if ( ! customElements.get('cart-discounts' ) ) {
	customElements.define(
		'cart-discounts',
		class CartDiscounts extends HTMLElement {

			constructor() {

				super();

				const button = this.querySelector('[data-js-discount-submit]');
				this.input = this.querySelector('[data-js-discount-input]');
				this.cartSubtotal = document.getElementById('AjaxCartSubtotal');
				this.cartDiscountError = this.querySelector('[data-js-discount-error]');
				this.discountCodes = document.querySelector('[data-js-discount-codes]');
				this._prefix = window.KT_PREFIX || '';
				this.#loadDiscountButtons();

				button.addEventListener('click', (e) => {
					e.preventDefault();
					if ( this.input.value.length > 0 ) {

						this.cartSubtotal.classList.add(`${this._prefix}processing`);
						if (this.discountCodes) {
							this.discountCodes.classList.add(`${this._prefix}processing`);
						}

						const existingDiscounts = Array.from(this.querySelectorAll('[data-js-discount]')).map(elm => elm.dataset.jsDiscount);
						
						const allDiscounts = [...existingDiscounts, this.input.value];
						const discountString = allDiscounts.join(',');
						const body = JSON.stringify({ discount: discountString });

						fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						})
							.then(response => response.json())
							.then(response => {
								const discountCodes = response.discount_codes;
								const inputValue = this.input.value;
								const matchingCode = discountCodes.find(code => 
									code.code === inputValue
								);

								if (matchingCode) {
									if (matchingCode.applicable) {
										this.#handleSuccess();
									} else {
										this.#handleError();
									}
								} else {
									this.#handleError();
								}
							})
							.catch(error => {
								this.#handleError();
								console.log(`Error: ${error}`);
							})

					}

				});

			}

			#handleSuccess(){
				fetch(`?section_id=${window.KT_FILE_PREFIX || ''}helper-cart`)
					.then(response => response.text())
					.then(text => {
						const sectionInnerHTML = window.renderHelperCart(text);
						this.refreshDiscounts(sectionInnerHTML);
					})
					.catch(() => this.#handleError())
			}

			refreshDiscounts(sectionInnerHTML){

				this.cartSubtotal.classList.remove(`${this._prefix}processing`);
				this.cartDiscountError.innerHTML = '';
				this.input.value = '';

				const sectionDiscountCodes = sectionInnerHTML.querySelector('[data-js-discount-codes]');
				if ( this.discountCodes && sectionDiscountCodes ) {
					this.discountCodes.innerHTML = sectionDiscountCodes.innerHTML;
					this.discountCodes.classList.remove(`${this._prefix}processing`);
					this.#loadDiscountButtons();
				}

				const appliedDiscountCodes = sectionDiscountCodes
					? Array.from(sectionDiscountCodes.querySelectorAll('[data-js-discount]')).map(el => ({ code: el.dataset.jsDiscount }))
					: [];
				KROWN.functions.dispatchStandardEvent('CartDiscountUpdateEvent', this, {
					discountCodes: appliedDiscountCodes,
					promise: Promise.resolve({ cart: null })
				});
			}

			#loadDiscountButtons(){
				this.querySelectorAll('[data-js-discount]').forEach(elm=>{
					if ( ! elm.classList.contains(`${this._prefix}enabled`) ) {
						elm.classList.add(`${this._prefix}enabled`);
						elm.addEventListener('click', (e)=>{
							e.preventDefault();
							this.cartSubtotal.classList.add(`${this._prefix}processing`);
							if (this.discountCodes) {
								this.discountCodes.classList.add(`${this._prefix}processing`);
							}
							const discountToRemove = elm.dataset.jsDiscount;
							
							const allDiscountElements = this.querySelectorAll('[data-js-discount]');
							const allDiscounts = Array.from(allDiscountElements).map(el => el.dataset.jsDiscount);
							
							const remainingDiscounts = allDiscounts.filter(discount => discount !== discountToRemove);
							
							const body = JSON.stringify({ 
								discount: remainingDiscounts.join(',') 
							});
							
							fetch(`${KROWN.settings.routes.cart_update_url}`, { 
								method: 'POST',
								headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
								body 
							})
								.then(() => {
									this.#handleSuccess();
								})
								.catch(error => {
									console.error(`Error: ${error}`);
								});
						});
					}
				});
			}
			
			#handleError(){
				this.cartSubtotal.classList.remove(`${this._prefix}processing`);
				if (this.discountCodes) {
					this.discountCodes.classList.remove(`${this._prefix}processing`);
				}
				this.cartDiscountError.innerHTML = window.KROWN.settings.locales.cart_discount_code_error;
			}

		}	
	)
}